import { SchedulerTaskManufacturingOrder } from './scheduler-task-manufacturing-order';

export class NewAndUpdatedSchedulerTaskManufacturingOrder {
  constructor(
    public newSchedulerTasksWithManufacturingOrders: SchedulerTaskManufacturingOrder[],
    public reSchedulerTasksWithManufacturingOrders: SchedulerTaskManufacturingOrder[],
  ) {
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/new-and-updated-scheduler-task-manufacturing-order.ts